import { EDITABLE_LIST_FIELD } from 'framework/list';
import { ProjectTeamMemberRoleField } from 'domain/shared/newProject';
import { AssumptionType } from '../../../assumptions/types';
import { getAssumptionDescriptionCell } from '../../../assumptions/List/getAssumptionTableCells';
import ControlListSection from '../../shared/ControlListSection';

const AssumptionSection = ({
  title,
  assumptions,
  emptyMessage,
}: {
  title: string;
  assumptions: AssumptionType[];
  emptyMessage: string;
}) => (
  <ControlListSection
    title={title}
    items={assumptions}
    listSource="assumptions"
    emptyMessage={emptyMessage}
    getTableCells={() =>
      Promise.resolve([
        getAssumptionDescriptionCell({ size: { xl: 9, lg: 8, md: 9 } }),
        {
          type: EDITABLE_LIST_FIELD,
          source: 'assignedRole',
          isEditor: false,
          component: ProjectTeamMemberRoleField,
          componentProps: { color: 'error.dark', label: '' },
          gridCellProps: {
            size: { xl: 2, lg: 3, md: 2 },
          },
        },
      ])
    }
  />
);

export default AssumptionSection;
